/**
 * @module lib/global/back-to-top-button
 * @description Displays the Back to Top button.
 */
import isNil from "lodash/isNil";
import ee from "lib/eventemitter";

/**
 * @method backToTopClick
 * @description click event handler for the Back to Top button above the footer
 */
function backToTopClick() {
  const backToTop = document.querySelector(".js-c-back-to-top-button");

  if (!isNil(backToTop)) {
    backToTop.addEventListener("click", function handleClick(e) {
      e.preventDefault();
      document.querySelector(".c-skip-link").scrollIntoView();
      this.blur();

      ee.trigger("analytics.trackGTMEvent", [{
        feature: "back to top button",
        type: "button",
        action: "scroll to top",
        label: "back to top"
      }, "clickEvent"]);

    }, false);
  }
}

/**
 * @method setup
 * @description button setup method
 */
export default function setup() {
  backToTopClick();
}
